import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { Row } from '@shadcn/components/ui/row'
import { Col } from '@shadcn/components/ui/col'

//Import Countdown
import Countdown from "react-countdown";

//Import Images
import logo from "../../assets/images/logo-dark.png";
import maintanence from "../../assets/images/maintenance.png";

class PagesComingsoon extends Component {
    constructor() {
        super();
        this.renderer.bind(this)
    }

    renderer = ({ days, hours, minutes, seconds, completed }) => {
        if (completed) {
            // Render a completed state
            return <span>You are good to go!</span>;
        } else {
            // Render a countdown
            return <>
            <div className="coming-box">{days} <span>Days</span></div> <div className="coming-box">{hours} <span>Hours</span></div> <div className="coming-box">{minutes} <span>Minutes</span></div> <div className="coming-box">{seconds} <span>Seconds</span></div>
            </>
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className="home-btn d-none d-sm-block">
                    <Link to="/" className="text-white"><i className="fas fa-home h2"></i></Link>
                </div>

                <div className="my-5 pt-sm-5">
                <div className="w-full px-3 mx-auto xl:max-w-[85%]">
                        <Row>
                            <Col lg="12">
                                <div className="text-center">
                                    <Link to="/" className="mb-5 flex justify-center items-center ">
                                    <img src={logo} alt="logo" className='h-6'/>
                                    </Link>
                                    <Row className="justify-content-center mt-5">
                                        <Col  className="sm:w-4/12">
                                            <div className="maintenance-img">
                                                <img src={maintanence} alt="" className="img-fluid mx-auto d-block" />
                                            </div>
                                        </Col>
                                    </Row>
                                    <h4 className="mt-12 text-[20px] text-[#495057] font-medium">Let's get started with Skote</h4>
                                    <p className="text-[#74788d]">It will be as simple as Occidental in fact it will be Occidental.</p>

                                    <Row className="justify-content-center mt-5">
                                        <Col className="md:w-8/12">
                                            <div className="counter-number">
                                                <Countdown
                                                    date="2020/12/31"
                                                    renderer={this.renderer}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default PagesComingsoon;
